import { render } from "./FranchiseRouter.vue?vue&type=template&id=79f237cd"
import script from "./FranchiseRouter.vue?vue&type=script&lang=js"
export * from "./FranchiseRouter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__